function Stack(this: TODOAny, initial: TODOAny) {
  this.xs = [initial]
  this.top = 0
}

Stack.prototype = {
  push(x: TODOAny) {
    this.top += 1
    if (this.top < this.xs.length) {
      this.xs[this.top] = x
    } else {
      this.xs.push(x)
    }
  },

  pushArrayReverse(xs: TODOAny) {
    for (let i = xs.length - 1; i >= 0; i -= 1) {
      this.push(xs[i])
    }
  },

  pop() {
    const x = this.peek()
    this.top -= 1
    return x
  },

  peek() {
    return this.xs[this.top]
  },

  isEmpty() {
    return this.top === -1
  },
}

export default function QueueFactory(initial: TODOAny) {
    // this is legacy code. we don't want to rewrite it to a class right now.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new (Stack as any)(initial);
}
